import { gsap, MotionPathPlugin } from "gsap/all";
import { useEffect } from 'react';

/**
 * For when we have an object that should follow a path. Tied to the user's scroll position.
 * @param {*} props 
 * @returns 
 */

function Key10({animate}) {
    gsap.registerPlugin(MotionPathPlugin);

    useEffect(() => {
      const pathElem = document.querySelector(".key10");
      const offsetFromTop = window.innerHeight * 0.3;
      const pathBB = pathElem.getBoundingClientRect();
      const startY = pathBB.top + window.scrollY - offsetFromTop;
     // const startY = document.querySelector("#path1").offsetTop - window.innerHeight + offsetFromTop;
      const finishDistance = 550;

      const tween = gsap.to("#key10", {
        duration: 5,
        paused: true,
        progress: animate ? 0.1 : 0.5,
        repeat: 0,
        reverse: true,
        keyframes: [
          { motionPath: {
            path: "#path10",
            align: "#path10",
            alignOrigin: [0.6, 0.2],
            autoRotate: 0,
            //autoRotate: 180,
            start: 0.1
          }
        }, {opacity: 0}
        ],
         ease:"none"
      });

      let requestId = null;
     // document.addEventListener("scroll", handleScroll);
      
      if (animate) {
        document.addEventListener("scroll", handleScroll);
        tween.progress(( window.scrollY - startY) / finishDistance);
      } else {
        document.removeEventListener("scroll", handleScroll);
        tween.progress(0.5);
      }

      function handleScroll() {
        if (!requestId) {
          requestId = requestAnimationFrame(update);
        }
      }

      function update() {
        // Update our animation
        
        if (animate) {
          tween.progress(( window.scrollY - startY) / finishDistance);
        } else {
          tween.progress(0.5);
        }
        // Let the scroll event fire again
        requestId = null;
      }
      return () => document.removeEventListener("scroll", handleScroll);
    }, [animate]);
   return (
     <div className="pathcontainer key10-container">
         <svg className="key10" xmlns="http://www.w3.org/2000/svg"  width="570.147" height="587.162">
            <image id="key10" href="/ReactAssets/CustomerJourney/keypaths/desktop/Key.svg" width="80" height="80" data-svg-origin="24 12" transform="matrix(0.01719,0.99985,-0.99985,0.01719,159.36864,6.14698)"/>
            <path xmlns="http://www.w3.org/2000/svg" stroke-dasharray="10 14" stroke-width="2" stroke-linejoin="round" stroke-linecap="round" stroke="#a29064" fill="none" d="m265.41498,1.00015c0,84.125 13.777,154.078 -110.723,190.776s-153.693,111.2 -153.693,211.19" transform="scale(-1,1) translate(-410, 0)" data-name="Path 1" id="path10"/>      
         </svg>
    </div>
   );
 }
 
 export default Key10;
